export const FORM_TYPES = {
	SZAMLA: 'SZAMLA',
	HITEL: 'HITEL'
};
